export {
  default as PageSections,
  type Props as PageSectionsProps
} from './PageSections';
